import { Routes, Route } from "react-router";
import SignInPage from "../pages/auth/signin";
import NotFoundPage from "../pages/NotFound";
import SignUpPage from "../pages/auth/signup";
import OtpPage from "../pages/auth/verifyOtp";
import { SiteRegisterPage } from "../pages/auth/regsiterSite";
import MainLayout from "../layout";
import ProtectedRoute from "./protected.route";
import PublicRoute from "./public.route";
import AllEvents from "../pages/allEvents";
import FavoriteEvents from "../pages/favorite";
import AttendantEvents from "../pages/attendantEvents";
import ProfilePage from "../pages/profile";
import PrivacyPolicy from "../pages/policy/privacyPolicy";
import TermAndCondtion from "../pages/policy/termAndCondition";
import EventDetailComponnent from "../pages/eventDetail";
import CalendarPage from "../pages/calendar";
import AllUser from "../pages/allUser.tsx";
import CustomAds from "../pages/customAds";

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/signin"
        element={<PublicRoute element={<SignInPage />} />}
      />
      <Route
        path="/signup"
        element={<PublicRoute element={<SignUpPage />} />}
      />
      <Route
        path="/verify-otp"
        element={<PublicRoute element={<OtpPage />} />}
      />
      <Route
        path="/register-site"
        element={<PublicRoute element={<SiteRegisterPage />} />}
      />
      <Route
        path="/home"
        element={
          <PublicRoute
            element={
              <div className="bg-bg h-screen overflow-y-auto p-6">
                <AllEvents />
              </div>
            }
          />
        }
      />
      <Route path="event-detail/:id" element={<EventDetailComponnent />} />

      {/* Protected Routes */}
      <Route path="/" element={<MainLayout />}>
        <Route path="/" element={<ProtectedRoute element={<AllEvents />} />} />
        <Route
          path="/favorite"
          element={<ProtectedRoute element={<FavoriteEvents />} />}
        />
        <Route
          path="/attendant-events"
          element={<ProtectedRoute element={<AttendantEvents />} />}
        />
        <Route
          path="/profile"
          element={<ProtectedRoute element={<ProfilePage />} />}
        />
        <Route
          path="/calendar"
          element={<ProtectedRoute element={<CalendarPage />} />}
        />
        <Route
          path="/all-users"
          element={<ProtectedRoute element={<AllUser />} />}
        />
        <Route
          path="/custom-ads"
          element={<ProtectedRoute element={<CustomAds />} />}
        />
        <Route
          path="/privacy-policy"
          element={<ProtectedRoute element={<PrivacyPolicy />} />}
        />
        <Route
          path="/term-and-conditions"
          element={<ProtectedRoute element={<TermAndCondtion />} />}
        />
      </Route>

      {/* 404 Route */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
